module.exports = __webpack_public_path__ + "img/Documentos.0f2eaadf.jpg";